export enum FieldNames {
  Email = 'email',
  Password = 'password',
  Password2 = 'password2',
  RecoveryToken = 'token',
}
